import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter } from "react-router-dom";
import { lenisRef } from "./lib/scroll";
import ErrorBoundary from "./components/ErrorBoundary";
import Landing from "./pages/Landing";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Landing />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
